import {IPlayer, ISquad} from "modules/types";
import {createAction} from "redux-act";

export const fetchSquadsRequest = createAction();
export const fetchSquadsSuccess = createAction<ISquad[]>();

export const fetchPlayersRequest = createAction();
export const fetchPlayersSuccess = createAction<IPlayer[]>();
